import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgShip = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 105,
	height: 60,
	viewBox: "0 0 105.0 60.0",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M 0.0 40.0 L 70.0 40.0 L 70.0 35.0 L 105.0 30.0 L 95.0 60.0 L 5.0 60.0 Z M 25.0 20.0 L 35.0 20.0 L 35.0 40.0 L 15.0 40.0 L 15.0 30.0 L 25.0 30.0 Z M 35.0 0.0 L 35.0 20.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})
});
export default SvgShip;
